import React from "react";

import dompurify from "isomorphic-dompurify";

import { type MultiPackProduct } from "@jti/fe-common";

import "./ProductMultipacks.scss";

export type ProductMultiPacksItemType = {
  item: MultiPackProduct;
};

const { sanitize } = dompurify;

export const ProductMultiPacksItem = ({ item }: ProductMultiPacksItemType) => {
  if (!item) {
    return <React.Fragment />;
  }

  return (
    <li key={item.sku} className={"product-multipacks__list-item"}>
      <a className={"product-multipacks__list-link"} href={item.pdpUrl ? item.pdpUrl : "#"}>
        <div className={"product-multipacks__list-item-title"}>
          <span>{item.name}</span>
        </div>
        {item.shortDescription && (
          <div
            className={"product-multipacks__list-item-description"}
            dangerouslySetInnerHTML={{ __html: sanitize(item.shortDescription) }}
          ></div>
        )}
      </a>
    </li>
  );
};
